// 日期格式化的共用小工具。原本 EventFunnelPage.js 的 toDateId() 跟
// ExportDialog.js 的 formatDateStr() 是逐字相同的實作，各自維護一份，
// 這裡合併成一個來源，其他檔案改成 import 這裡的。

/** Date -> "yyyy-MM-dd"（用瀏覽器本地時區）。 */
export function toDateId(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** "yyyy-MM-dd" -> Date（本地時區午夜）。toDateId 的反向操作。 */
export function parseDateStr(str) {
  const [y, m, d] = str.split("-").map(Number);
  return new Date(y, m - 1, d);
}

/** 回傳最近 n 天（含今天）的 {start, end} date-id 區間，預設用在事件漏斗總覽的日期篩選器。 */
export function lastNDays(n) {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - (n - 1));
  return { start: toDateId(start), end: toDateId(end) };
}

/** 展開 [start, end] 區間內每一天的 date-id 陣列（含頭尾）。 */
export function dateRangeList(start, end) {
  const dates = [];
  let cur = new Date(start);
  const last = new Date(end);
  while (cur <= last) {
    dates.push(toDateId(cur));
    cur.setDate(cur.getDate() + 1);
  }
  return dates;
}

// occurred_at 存的是 UTC ISO8601（見 event_logger.dart），這裡轉成台灣時間再顯示，
// 不能直接對字串做 replace/slice，否則顯示出來的時間會比實際慢 8 小時。
export function formatOccurredAt(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("zh-TW", {
    timeZone: "Asia/Taipei",
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

// UserCalendar 用來對齊「date-id 一律以 UTC+8 為準」的另一套換算方式，跟上面的
// toDateId（用瀏覽器本地時區）語意不同、不能互相取代——瀏覽器不在 UTC+8 時區時
// 兩者結果會不一樣，這是既有行為，這次搬檔案不改動它的邏輯，只搬位置。
export function formatDateUTC8(d) {
  const utc8 = new Date(d.getTime() + 8 * 60 * 60 * 1000);
  const y = utc8.getUTCFullYear();
  const m = String(utc8.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(utc8.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}
